<div
  [ngClass]="{ 'profile-pic': true }"
  [title]="name || 'Foto de Perfil'"
>
  <img
    *ngIf="imageSrc; else acronym"
    [src]="imageSrc"
    [alt]="name || 'foto de perfil'"
  />
  <ng-template #acronym>
    <span>{{ nameChars | uppercase }}</span>
  </ng-template>
</div>
